import { render, staticRenderFns } from "./VaildEmail.vue?vue&type=template&id=2483059b&scoped=true"
import script from "./VaildEmail.vue?vue&type=script&lang=js"
export * from "./VaildEmail.vue?vue&type=script&lang=js"
import style0 from "./VaildEmail.vue?vue&type=style&index=0&id=2483059b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2483059b",
  null
  
)

export default component.exports